export const environment = {
  production: false,
  baseUrl: 'https://test-welldata.oregon.gov',
  useHash: false,
  hmr: false,
  showThemeToggle: true,
  translateText: false,
  collapsibleSidebar: false,
  useAppInsights: false,
  appInsightsInstrumentationKey: 'e6f30bb6-a160-4d69-a8d2-8642430020c1',
  useTimeout: true,
  idleInterval: 1800,
  build: 'Test',
  version: '7.0.0',
  displaySidebar: true,
  theme: 'light',
  publicApi: 'https://test-welldata.oregon.gov/api/public/',
  privateApi: 'https://test-welldata.oregon.gov/api/private/',
  canManageB2CUsers: false,
  auth: {
    defaultAuth: "AAD",
    useAdIdentity: false,
    b2c: {
      clientId: '',
      authority: '',
      authorityDomain: '',
      domain: '',
      signUpSignInPolicy: '',
      scopes: [],
      redirectUri: '',
      postLogoutRedirectUri: ''
    },
    aad: {
      clientId: '6cdb1906-48ca-479f-977b-3e4f21ef0d36',
      scopes: ['api://6cdb1906-48ca-479f-977b-3e4f21ef0d36/user.access'],
      groups: ['4da35628-4b80-4e36-886d-fa969e5c0461'],
      authority: 'https://login.microsoftonline.com/658e63e8-8d39-499c-8f48-13adc9452f4c/',
      redirectUri: 'https://test-welldata.oregon.gov',
    }
  },
  azure: {
    storage: {
      account: "oregonwelldatadev",
      tableName: "OregonWellVouchers",
      sasToken: "?sv=2021-06-08&ss=bfqt&srt=sco&sp=rwdlacupiytfx&se=2030-01-01T00:23:29Z&st=2022-07-26T15:23:29Z&spr=https&sig=fCHuxL5B7CC%2FBOSXsOd1T3xuFgkbYYY2mrgKqf262c4%3D"
    },
    storageLubgwma: {
      account: "oregonwelldatadev",
      tableName: "OregonWellLubgwma",
      sasToken: "?sv=2021-06-08&ss=bfqt&srt=sco&sp=rwdlacupiytfx&se=2030-01-01T00:23:29Z&st=2022-07-26T15:23:29Z&spr=https&sig=fCHuxL5B7CC%2FBOSXsOd1T3xuFgkbYYY2mrgKqf262c4%3D"
    },
    storageLubgwmaSurvey123: {
      account: "oregonwelldatadev",
      tableName: "OregonWellLubgwmaSurvey123",
      sasToken: "?sv=2021-06-08&ss=bfqt&srt=sco&sp=rwdlacupiytfx&se=2030-01-01T00:23:29Z&st=2022-07-26T15:23:29Z&spr=https&sig=fCHuxL5B7CC%2FBOSXsOd1T3xuFgkbYYY2mrgKqf262c4%3D"
    }
  },
  powerbiLink: "https://app.powerbigov.us/groups/d2c16d23-49ae-4712-8c17-9de7761ab6d0/list",
  enableHttpsRedirect: true,
};

